export const RAK_ID_AUTH_KEYS = {
  STATE: 'state',
  ID_TOKEN: 'id_token',
  ACCESS_TOKEN: 'access_token',
  REFRESH_TOKEN: 'refresh_token',
};
